import { IonDatetime, IonPopover } from '@ionic/react';
import React from 'react';

import {
  CALENDAR_MONTHS_DISPLAY_RANGE_FUTURE,
  CALENDAR_MONTHS_DISPLAY_RANGE_PAST
} from '@/utils/constants';
import { now } from '@/utils/helpers/now';
import { addMonths, endOfWeek, format, startOfWeek, subMonths } from 'date-fns';

import './CalendarPopover.css';

interface CalendarPopoverProps {
  isOpen: boolean;
  onDidDismiss: () => void;
  onSelectDate: (event: CustomEvent) => void;
}

const CalendarPopover: React.FC<CalendarPopoverProps> = ({
  isOpen,
  onDidDismiss,
  onSelectDate
}) => {
  return (
    <IonPopover
      className="calendar-popover"
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
    >
      <IonDatetime
        min={format(
          startOfWeek(subMonths(now(), CALENDAR_MONTHS_DISPLAY_RANGE_PAST)),
          'yyyy-MM-dd'
        )}
        max={format(
          endOfWeek(addMonths(now(), CALENDAR_MONTHS_DISPLAY_RANGE_FUTURE)),
          'yyyy-MM-dd'
        )}
        presentation="date"
        onIonChange={onSelectDate}
      />
    </IonPopover>
  );
};

export default CalendarPopover;
